module.exports = __webpack_public_path__ + "static/nine_noir_lives-0707ed30978f7bd840c26eba78649a4b.png";